import { render, staticRenderFns } from "./supporter-offerings.vue?vue&type=template&id=628351fd&scoped=true&"
import script from "./supporter-offerings.vue?vue&type=script&lang=ts&"
export * from "./supporter-offerings.vue?vue&type=script&lang=ts&"
import style0 from "./supporter-offerings.vue?vue&type=style&index=0&id=628351fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628351fd",
  null
  
)

export default component.exports